import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'pa-card-add',
  templateUrl: './card-add.component.html',
  styleUrls: ['./card-add.component.scss']
})
export class CardAddComponent implements OnInit {

  id: string;
  imageUrl: string;

  constructor(private activatedRoute: ActivatedRoute) {
    this.activatedRoute.params.subscribe(p => this.id = p.id);
    if (this.id === 'paycell-card') {
      this.imageUrl = 'assets/images/paycell-card-big.png';
    } else if (this.id === 'credit-card') {
      this.imageUrl = 'assets/images/credit-card-big.png';
    } else if (this.id === 'create-virtual-card') {
      this.imageUrl = 'assets/images/paycell-virtual-card.png';
    } else if (this.id === 'spending-money-card') {
      this.imageUrl = 'assets/images/spending-money-card-big.png';
    }
  }

  ngOnInit(): void {
  }

}
